import React, { Component } from 'react'
import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'
import { Full as Loading } from 'components/Loading'
import { Route, Link, useHistory } from 'react-router-dom'
import { Button } from '@arnsbogroup/react-voicearchive'
import Icon from 'components/Icon'
import 'github-markdown-css'

export default ({ title, subtitle, loading, docs, match }) => {
  const documents = docs && docs.status !== 'unauthorized' ? docs : [];

  const history = useHistory()

  return (
    <div className="flex flex-col w-full h-full">
      <div className="w-full flex justify-between items-center border-b border-gray-200 px-4 lg:px-6">
        <div className="pt-3 lg:pt-5 space-y-6 shadow-sm">
          <div className="pb-5">
            <h3 className="text-lg leading-6 font-medium text-gray-900">
              { title }
            </h3>
            <p className="mt-2 max-w-4xl text-sm text-gray-500">
              { subtitle }
            </p>
          </div>
        </div>

        <div className="sm:hidden p-4">
          <label htmlFor="tabs" className="sr-only">Select a tab</label>
          <select id="tabs" name="tabs" className="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md" value={match.path} onChange={({ target: { value } }) => history.push(value)}>
            { (documents || []).map(({ title, body }) => (
              <option key={`${title}-link`} value={`/docs/${title}`}>
                { title.split('-').map((x) => x[0].toUpperCase() + x.substr(1).toLowerCase()).join(' ') }
              </option>
            )) }
          </select>
        </div>

        { history.length > 2 &&
          <div className="flex justify-center items-center">
            <Button variant="outline" onClick={() => history.goBack()} size="sm">
              <Icon icon="arrow-left" /> Back
            </Button>
          </div>
        }
      </div>


      <div className="flex grow overflow-scroll">
        <div className="h-full hidden sm:block sm:w-1/4 divide-y divide-gray-200 border-r border-gray-200">
          { (documents || []).map(({ title, body }) => (
            <Link
              key={`${title}-link`} to={`/docs/${title}`}
              className="block w-full text-gray-600 text-sm px-4 lg:px-6 py-2 hover:bg-blue-50"
            >
              { (title[0].toUpperCase() + title.substr(1).toLowerCase()).replaceAll('-', ' ') }
            </Link>
          )) }
        </div>

        <div className="w-full sm:w-3/4 overflow-scroll">

          { (docs && docs.status === 'unauthorized') && (
            <div className="px-4 sm:px-6 lg:max-w-6xl lg:mx-auto lg:px-8">
              <div className="pt-10 pb-32 markdown-body">
                <h1 className="text-2xl font-bold">Unauthorized</h1>
                <p>You are not authorized to view this documentation.</p>
                <Button variant="outline" onClick={() => history.push('/user/sign-in') } size="sm">Sign In</Button>
              </div>
            </div>
          )}

          { !documents || loading ? (
            <Loading />
          ) : (
            <div className="px-4 sm:px-6 lg:max-w-6xl lg:mx-auto lg:px-8">
              { (documents || []).map(({ title, body }) => (
                <Route key={`${title}-content`} path={`/docs/${title}`}>
                  <div className="pt-10 pb-32 markdown-body">
                    <ReactMarkdown
                      rehypePlugins={[rehypeRaw]}
                      children={body}
                      components={{
                        img: ({ node, ...props }) => <img className="border border-gray-400 shadow-sm m-8" {...props} />,
                        ul: ({ node, ...props }) => <ul className="list-disc" {...props } />,
                        ol: ({ node, ...props }) => <ol className="list-decimal" {...props } />,
                        a: ({ node, href, ...props }) => href.startsWith('/') ?
                          <Link to={href} {...props} /> :
                          <a href={href} {...props } />
                      }}
                    />
                  </div>
                </Route>
              )) }
            </div>
          ) }
        </div>
      </div>
    </div>
  )
}
